// Inline SVG icons (pixel-art style where it fits the blocky theme).

function pix(rows, pal, cls = '') {
  const h = rows.length, w = rows[0].length;
  let r = '';
  for (let y = 0; y < h; y++)
    for (let x = 0; x < w; x++) {
      const c = pal[rows[y][x]];
      if (c) r += `<rect x="${x}" y="${y}" width="1.02" height="1.02" fill="${c}"/>`;
    }
  return `<svg class="ico ${cls}" viewBox="0 0 ${w} ${h}" shape-rendering="crispEdges" aria-hidden="true">${r}</svg>`;
}

const HEART = ['.oo.oo.', 'orrorro', 'rwrrrrr', 'rrrrrrr', '.rrrrr.', '..rrr..', '...r...'];
export function heartSVG(full) {
  return pix(HEART, full ? { o: '#ff6a85', r: '#ff2a4a', w: '#ffd0d8' } : { o: '#4a2530', r: '#2a141a', w: '#4a2530' }, 'heart-ico');
}

export const ICON = {
  coin: pix(
    ['..yyyy..', '.yYYYYy.', 'yYOOOOYy', 'yYOyyYOy', 'yYOOOYOy', 'yYOyOOYy', '.yYYYYy.', '..yyyy..'],
    { y: '#b8700a', Y: '#ffd23f', O: '#f0a818' },
    'coin-ico'
  ),
  gem: pix(['.cCCc.', 'cCWCCc', 'CCCCCC', '.CCCC.', '..CC..'], { c: '#1aa8c0', C: '#4ff0ff', W: '#e8ffff' }, 'gem-ico'),
  star: `<svg class="ico star-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2l2.9 6.2 6.8.8-5 4.6 1.3 6.7L12 17.2l-6 3.3 1.3-6.7-5-4.6 6.8-.8z"/></svg>`,
  pause: `<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="4" width="5" height="16" rx="1.5" fill="currentColor"/><rect x="14" y="4" width="5" height="16" rx="1.5" fill="currentColor"/></svg>`,
  lock: pix(['..kkk..', '.k...k.', '.k...k.', 'yyyyyyy', 'yyykyyy', 'yyykyyy', 'yyyyyyy'], { k: '#9aa4b2', y: '#ffc21f' }, 'lock-ico'),
  check: `<svg class="ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="3.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  crown: pix(['y..y..y', 'yy.y.yy', 'yyyyyyy', 'yryyyry', 'yyyyyyy'], { y: '#ffd23f', r: '#ff3355' }, 'crown-ico'),
};
